import { UPDATE_LOCALE } from "../constants/appConstants";

export const locale = (state = "", action) => {
  switch (action.type) {
    case UPDATE_LOCALE:
      return action.payload;
    default:
      return state;
  }
};
